import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        mt: "auto",
        py: 2,
        px: 3,
        textAlign: "center",
        borderTop: "1px solid #eee",
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} Smart Video Processor. All rights reserved.
      </Typography>

      <Box sx={{ mt: 1 }}>
        <Link component={RouterLink} to="/terms" sx={{ mx: 1 }}>
          Terms
        </Link>
        <Link component={RouterLink} to="/privacy" sx={{ mx: 1 }}>
          Privacy
        </Link>
        <Link component={RouterLink} to="/contact" sx={{ mx: 1 }}>
          Contact Support
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;